import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Show } from "@clerk/react";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import { SignInPage, SignUpPage } from "@/pages/AuthPages";
import AppShell from "@/components/AppShell";
import Overview from "@/pages/member/Overview";
import Activate from "@/pages/member/Activate";
import Team from "@/pages/member/Team";
import Earnings from "@/pages/member/Earnings";
import Withdraw from "@/pages/member/Withdraw";
import AddMoney from "@/pages/member/AddMoney";
import TopUps from "@/pages/admin/TopUps";
import AdminOverview from "@/pages/admin/AdminOverview";
import Payments from "@/pages/admin/Payments";
import Withdrawals from "@/pages/admin/Withdrawals";
import Members from "@/pages/admin/Members";
import Settings from "@/pages/admin/Settings";
import Products from "@/pages/admin/Products";
import Orders from "@/pages/admin/Orders";
import Shop from "@/pages/member/Shop";

const Protected = ({ children }) => (
  <>
    <Show when="signed-in">{children}</Show>
    <Show when="signed-out"><Navigate to="/sign-in" replace /></Show>
  </>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ClerkAuthProvider>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/sign-in/*" element={<SignInPage />} />
            <Route path="/sign-up/*" element={<SignUpPage />} />
            <Route element={<Protected><AppShell /></Protected>}>
              <Route path="/dashboard" element={<Overview />} />
              <Route path="/dashboard/activate" element={<Activate />} />
              <Route path="/dashboard/team" element={<Team />} />
              <Route path="/dashboard/earnings" element={<Earnings />} />
              <Route path="/dashboard/withdraw" element={<Withdraw />} />
              <Route path="/dashboard/add-money" element={<AddMoney />} />
              <Route path="/admin/topups" element={<TopUps />} />
              <Route path="/admin" element={<AdminOverview />} />
              <Route path="/admin/payments" element={<Payments />} />
              <Route path="/admin/withdrawals" element={<Withdrawals />} />
              <Route path="/admin/members" element={<Members />} />
              <Route path="/admin/settings" element={<Settings />} />
              <Route path="/admin/products" element={<Products />} />
              <Route path="/admin/orders" element={<Orders />} />
              <Route path="/dashboard/shop" element={<Shop />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster theme="dark" position="top-right" />
        </ClerkAuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
